// extracted by mini-css-extract-plugin
module.exports = {"Label":"Label_Label__1rEO0","menu__label":"Label_menu__label__1l_XE"};